import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Template } from 'src/app/models/template.model';
import { Cabecalho } from 'src/app/models/cabecalho.model';
import { RequestsService } from '../../services/requests.service';
import { SideMenuLiveViewComponent } from '../../components/side-menu-live-view/side-menu-live-view.component';
import { JsonViewerComponent } from '../../_helpers/json-viewer/json-viewer.component';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'editor-template',
  templateUrl: './editor-template.component.html',
  styleUrls: ['./editor-template.component.scss']
})
export class EditorTemplateComponent implements OnInit {

  @ViewChild('menuLateral', { static: true }) public menuLateral: SideMenuLiveViewComponent
  @ViewChild('modalDatafield', { static: true }) private modalDatafield: JsonViewerComponent
  public cabecalhoSelecionado: Cabecalho;
  public report: Template = new Template();
  editorOptions = {theme: 'vs-dark', language: 'html'};
  editorOptions2 = {theme: 'vs-dark', language: 'javascript'};
  sidenavOpened = false;
  closed = false;
  constructor(private route: ActivatedRoute, private requestService: RequestsService, private toastService: ToastService) {

  }

  ngOnInit() {
    this.toastService.showSuccess("Alterações salvas com sucesso!");
    this.route.queryParams.subscribe(params => {
      this.route.params.subscribe(pathParam => {
        let paramsString = JSON.stringify(params);

        this.requestService.getTemplate(pathParam['idReport']).subscribe(result => {
          this.report = result;
          this.menuLateral.iniciar(this.report, false);
        });
      });
    });

  }

  loadScriptByUrl() {
    let scriptElem = document.getElementById("customscript");
    if(scriptElem)
    scriptElem.remove();
    
    let dynamicScript = document.createElement("script");
    dynamicScript.id="customscript";
    dynamicScript.type = "text/javascript";
    dynamicScript.async = true;
    dynamicScript.text = this.report.script;
    document.body.appendChild(dynamicScript);
  }
  openModalDatafield() {
    let datafield = this.menuLateral.datasets.find(x => x.idDataset == this.report.idDataset);
    this.modalDatafield.abrir("Datafields (Mapeamento) dos Campos de Consulta", datafield.dataFieldsJson, true);
  }

  openModalCommand() {
    //this.toastService.showDangerWithHeader("Erro ao salvar as alterações!","")
    // let datafield = this.menuLateral.datasets.find(x => x.idDataset == this.report.idDataset);
    // this.modalDatafield.abrir("Comando Sql Dataset Com Filtros", datafield.comando, false);
  }


  updateTemplate() {
    this.requestService.updateTemplate(this.report).subscribe(x => {
      this.toastService.showSuccess("Alterações salvas com sucesso!");
    }
      , error => {
        this.toastService.showDanger("Erro ao salvar as alterações!" + error)
      });
  }
}
